"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../structures/LootTable"));
const SimpleOpenable_1 = __importDefault(require("../../structures/SimpleOpenable"));
const Easy_1 = require("../clues/Easy");
const Elite_1 = require("../clues/Elite");
const Hard_1 = require("../clues/Hard");
const Master_1 = require("../clues/Master");
const Medium_1 = require("../clues/Medium");
const LuckyImplingTable = new LootTable_1.default()
    .add(Easy_1.EasyClueTable)
    .add(Medium_1.MediumClueTable)
    .add(Hard_1.HardClueTable)
    .add(Elite_1.EliteClueTable)
    .add(Master_1.MasterClueTable);
exports.default = new SimpleOpenable_1.default({
    id: 19732,
    name: 'Lucky Impling',
    aliases: ['lucky imp', 'lucky impling'],
    table: LuckyImplingTable
});
//# sourceMappingURL=LuckyImp.js.map